import AddToMemberListStep from './AddToMemberListStep';
import ChooseActionStep from './ChooseActionStep';
import { MoveToCofeeAction, MoveToCofeeStep } from './constants';
import QuickCollectGroupStep from './QuickCollectGroupStep';
import QuickCollectStep from './QuickCollectStep';
import ReviewStep from './ReviewStep';
import {
  AddToMemberListFormData,
  QuickCollectFormData,
  QuickCollectGroupFormData,
  ReviewField
} from './types';

interface ModalBodyProps {
  currentStep: MoveToCofeeStep;
  selectedAction: MoveToCofeeAction | null;
  onSelectAction: (action: MoveToCofeeAction) => void;
  leadName: string;
  memberListForm: AddToMemberListFormData;
  quickCollectForm: QuickCollectFormData;
  quickCollectGroupForm: QuickCollectGroupFormData;
  onMemberListChange: (data: Partial<AddToMemberListFormData>) => void;
  onQuickCollectChange: (data: Partial<QuickCollectFormData>) => void;
  onQuickCollectGroupChange: (data: Partial<QuickCollectGroupFormData>) => void;
  reviewFields: ReviewField[];
  nameApiError?: string;
}

const ModalBody = ({
  currentStep,
  selectedAction,
  onSelectAction,
  leadName,
  memberListForm,
  quickCollectForm,
  quickCollectGroupForm,
  onMemberListChange,
  onQuickCollectChange,
  onQuickCollectGroupChange,
  reviewFields,
  nameApiError
}: ModalBodyProps) => {
  const renderConfigureStep = () => {
    if (selectedAction === MoveToCofeeAction.ADD_TO_MEMBER_LIST) {
      return (
        <AddToMemberListStep
          leadName={leadName}
          formData={memberListForm}
          nameApiError={nameApiError}
          onChange={onMemberListChange}
        />
      );
    }
    if (selectedAction === MoveToCofeeAction.QUICK_COLLECT) {
      return (
        <QuickCollectStep
          leadName={leadName}
          formData={quickCollectForm}
          nameApiError={nameApiError}
          onChange={onQuickCollectChange}
        />
      );
    }
    if (selectedAction === MoveToCofeeAction.QUICK_COLLECT_ADD_TO_GROUP) {
      return (
        <QuickCollectGroupStep
          leadName={leadName}
          formData={quickCollectGroupForm}
          nameApiError={nameApiError}
          onChange={onQuickCollectGroupChange}
        />
      );
    }
    return null;
  };

  return (
    <div className="py-4">
      {currentStep === MoveToCofeeStep.CHOOSE_ACTION && (
        <ChooseActionStep
          selectedAction={selectedAction}
          onSelectAction={onSelectAction}
        />
      )}
      {currentStep === MoveToCofeeStep.CONFIGURE && renderConfigureStep()}
      {currentStep === MoveToCofeeStep.REVIEW && selectedAction && (
        <ReviewStep action={selectedAction} fields={reviewFields} />
      )}
    </div>
  );
};

export default ModalBody;
